import type { PropertyOperation } from "./schemas/property";

/**
 * Operações de imóvel compatíveis com a operação escolhida no filtro.
 *
 * Um imóvel anunciado como "venda e locação" atende tanto quem procura venda
 * quanto quem procura locação — comparar por igualdade exata o escondia dos
 * dois. Já escolher "venda e locação" é uma busca por esse arranjo específico,
 * então aí o filtro é restritivo.
 *
 * Espelha o `PropertyOperationFilter` do crm-api: o filtro real acontece no
 * servidor; isto existe para o mock não divergir da API (mock com regra
 * diferente esconde bug).
 */
export function allowedOperations(selected: PropertyOperation): PropertyOperation[] {
  switch (selected) {
    case "sale":
      return ["sale", "sale_rent"];
    case "rent":
      return ["rent", "sale_rent"];
    default:
      return ["sale_rent"];
  }
}

/** O imóvel aparece quando a operação escolhida no filtro o inclui. */
export function matchesOperation(
  propertyOperation: PropertyOperation,
  selected: PropertyOperation | undefined,
): boolean {
  if (!selected) return true;
  return allowedOperations(selected).includes(propertyOperation);
}
